import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Loading from "../../Components/Common/Loading";
import InputText from "../../Components/sectioninput/formelement/InputText";
import {
  getContactItem,
  // sendEmail,
  setContactViewed,
} from "../../REDUX/actions/contact";
import moment from "moment";
// import CustomButton from "../../Components/Common/CustomButton";

const translateRequestType = (type) => {
  const typeMap = {
    "Demande d'information": "Information Request",
  };
  return typeMap[type] || type;
};

const ContactItemView = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  console.log({ user })
  const { contactLoading, contactItem } = useSelector(
    (state) => state.contactsReducer
  );

  useEffect(() => {
    dispatch(getContactItem(params.id));
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (contactItem) {
      const viewedBy = contactItem.attributes.viewedBy;
      const cleanedViewedBy = viewedBy ? viewedBy.replace(/\bnull\b,?\s*/g, "") : "";
      if (!cleanedViewedBy || !cleanedViewedBy.includes(user.firstName)) {
        dispatch(
          setContactViewed(
            contactItem.id,
            `${cleanedViewedBy ? cleanedViewedBy + ", " : ""}${user.firstName
            } on ${moment().format("MM-DD-YYYY")}`
          )
        );
      }
    } // eslint-disable-next-line
  }, [contactItem]);

  // const handleMailing = () => {
  //   dispatch(sendEmail(contactItem.id));
  // };

  return contactLoading || !contactItem ? (
    <Loading />
  ) : (
    <div className="container-fluid bg-white shadowed p-5 rounded-10 ">
      <div className="row f24 align-items-center mb-2">Customer Data</div>
      <div className="row f14 align-items-center mb-5">
        {contactItem.attributes.viewedBy
          ? contactItem.attributes.viewedBy.replace(/\bnull\b,?\s*/g, "").replaceAll(",", ", ")
          : ""}
      </div>
      <div className="row">
        <div className="col-6">
          {contactItem.attributes.firstName ? (
            <InputText
              labelinput={"First Name"}
              readOnly
              value={contactItem.attributes.firstName}
              flag={false}
            />
          ) : null}
          {contactItem.attributes.lastName ? (
            <InputText
              labelinput={"Last Name"}
              readOnly
              value={contactItem.attributes.lastName}
              flag={false}
            />
          ) : null}
          {contactItem.attributes.email ? (
            <InputText
              labelinput={"E-mail"}
              readOnly
              value={contactItem.attributes.email}
              flag={false}
            />
          ) : null}
          {contactItem.attributes.phoneNumber ? (
            <InputText
              labelinput={"Phone"}
              readOnly
              value={contactItem.attributes.phoneNumber}
              flag={false}
            />
          ) : null}
          {contactItem.attributes.adresse ? (
            <InputText
              labelinput={"Address"}
              readOnly
              value={contactItem.attributes.adresse}
              flag={false}
            />
          ) : null}
          {contactItem.attributes.postalCode ? (
            <InputText
              labelinput={"Postal Code"}
              readOnly
              value={contactItem.attributes.postalCode}
              flag={false}
            />
          ) : null}
          {contactItem.attributes.city ? (
            <InputText
              labelinput={"City"}
              readOnly
              value={contactItem.attributes.city}
              flag={false}
            />
          ) : null}
        </div>
        <div className="col-6">
          {contactItem.attributes.type ? (
            <InputText
              labelinput={"Request Type"}
              readOnly
              value={translateRequestType(contactItem.attributes.type)}
              flag={false}
            />
          ) : null}
          {contactItem.attributes.information ? (
            <InputText
              labelinput={"Requested Information"}
              readOnly
              value={contactItem.attributes.information}
              flag={false}
            />
          ) : null}
          {contactItem.attributes.interestedIn ? (
            <InputText
              labelinput={"Range"}
              readOnly
              value={contactItem.attributes.interestedIn}
              flag={false}
            />
          ) : null}
         
          {contactItem.attributes.buyPeriod ? (
            <InputText
              labelinput={"Potential Purchase Period"}
              readOnly
              value={contactItem.attributes.buyPeriod}
              flag={false}
            />
          ) : null}
          {contactItem.attributes.message ? (
            <>
              <label className="f16 text-start w-100 mb-1">Message</label>
              <textarea
                className="styleInput readOnlyArea w-100 rounded-3"
                readOnly
                value={contactItem.attributes.message}
              />
            </>
          ) : null}
          {/* <div className="mt-5"></div> <CustomButton buttonText={"Transmettre"} callBack={handleMailing}></CustomButton> */}
        </div>
      </div>
    </div>
  );
};

export default ContactItemView;
